<template>
  <div class="my-no-message-box">
    <div class="tc-100"></div>
    <div class="my-no-message-inner-img-box">
      <img src="../../../assets/img/noMessage/no-message2.png" alt="">
    </div>
    <div class="my-no-message-inner-font">{{msg}}</div>
  </div>
</template>
<script>
// <NoMessage2></NoMessage2>
export default {
  name: 'NoMessage2',
  mixins: [],
  extends: {},
  props: {
    msg: {
      type: String,
      default: '暂无数据'
    }
  },
  data () {
    return {
    }
  },
  computed: {},
  components: {},
  filter: {},
  watch: {},
  methods: {},
  created () {
  },
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
// @media  screen and (min-width:1218px){}
// @media  screen and (max-width:1217px){}
// @media  screen and (max-width:992px){}

.my-no-message-box{
  width: 100%;
  height: 424px;
  background: #fff;
  margin: 0 auto;
  .my-no-message-inner-img-box{
    width: 177px;
    height: 177px;
    margin: 0 auto;
    >img{
      width: 100%;
      height: 100%;
    }
  }
  .my-no-message-inner-font{
    text-align: center;
    width: 100%;
    height: 57px;
    line-height: 57px;
    font-size:16px;
    font-weight:400;
    color:#666;
  }
}
</style>
